/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Motivo per cui una domanda del bando di origine non si puo\' importare
 */
export enum MotivoEsclusioneImportazioneEsercente {

    ESERCENTE_BLOCCATO = 'ESERCENTE_BLOCCATO',

    GIA_PRESENTE_SU_DESTINAZIONE = 'GIA_PRESENTE_SU_DESTINAZIONE',

    NESSUN_NEGOZIO = 'NESSUN_NEGOZIO',

    ESERCENTE_ANONIMIZZATO = 'ESERCENTE_ANONIMIZZATO',

    PARTITA_IVA_GIA_CON_DOMANDA = 'PARTITA_IVA_GIA_CON_DOMANDA'
}

